import React, { useState } from 'react'
import Header from '../../components/Header/Header'
import HamburgerMenu from '../../components/Sidebar/HamburgerMenu';
import VariationSelection from '../../components/MenuSelection/VariationSelection';
import { menuselection_addon, menuselection_cutomize, menuselection_meal, menuselection_varitaion, refPageRoute } from '../../constant/constant';
import useCustomNavigate from '../../hooks/useCustomNavigate';
import useCustomParams from '../../hooks/useCustomParams';
import CustomizeItemSelection from '../../components/MenuSelection/CustomizeItemSelection';
import MealSelection from '../../components/MenuSelection/MealSelection';
import AddOnSelection from '../../components/MenuSelection/AddOnSelection';
const MenuSelection = () => {
    const navigate = useCustomNavigate();
    const params_id = useCustomParams('id');
    const [sidebar, setSidebar] = useState(false);
    const handleSidebar = () => {
        setSidebar(!sidebar);
    };
    const onCloseModal = () => {
        navigate('/menu')
    }
    // console.log("params_id", params_id)
    return (
        <>
            <div className="topheader" >
                <div className="pageHeader">
                    <Header handleSidebar={handleSidebar} />
                </div>
            </div>
            <div className={`${sidebar ? "left-0" : "left-[-50rem]"} md:hidden block absolute h-screen w-screen transition-all z-[51] bg-white`}>
                <HamburgerMenu handleSidebar={handleSidebar} sidebar={sidebar} />
            </div>
            {(params_id == menuselection_varitaion) ?
                <VariationSelection
                    refrencePage={refPageRoute}
                    onCloseModal={onCloseModal}
                />
                : ''}

            {(params_id == menuselection_cutomize) ?
                <CustomizeItemSelection
                    refrencePage={refPageRoute}
                    onCloseModal={onCloseModal}
                /> : ''}

            {(params_id == menuselection_meal) ?
                <MealSelection
                    refrencePage={refPageRoute}
                    onCloseModal={onCloseModal}
                /> : ''}
            {(params_id == menuselection_addon) ?
                <AddOnSelection
                    refrencePage={refPageRoute}
                    onCloseModal={onCloseModal}
                /> : ''}



        </>
    )
}

export default MenuSelection